import { Routes, Route, Navigate } from "react-router-dom";
import { ProtectedRoute } from "../../components/protect-route";
import { TeacherDashboard } from "../../teacher/dashboard";
import { TestManagement } from "../../teacher/test-management";
import {
  ROUTE_DASHBOARD,
  ROUTE_STUDENT_LEADERBOARD,
  ROUTE_STUDENT_PERFORMANCE,
  ROUTE_TEST_CREATION,
  ROUTE_TEST_MANAGEMENT,
  ROUTE_TEACHER_QUIZ,
  ROUTE_QUESTION_PAPERS,
  ROUTE_QUESTION_BANK,
  ROUTE_QUESTION_BANK_VIEW,
  ROUTE_KNOWLEDGE_BASE,
  ROUTE_ADMIN_QUIZ_ROOM,
  ROUTE_ADMIN_LIVE_QUIZ_ROOM,
  ROUTE_CLASSROOM_QUIZ_SUMMARY,
} from "../teacherRoute.js";
import { StudentPerformance } from "../../teacher/student-performance";
import { TeacherLeaderBaord } from "../../teacher/teacher-leaderboard/index.jsx";
import { AdminQuiz } from "../../teacher/admin-quiz/index.jsx";
import QuestionBank from "../../teacher/question-bank/index.jsx";
import { QuestionBankView } from "../../teacher/question-bank-view/index.jsx";
import { KnowledgeBase } from "../../teacher/knowledge-base/index.jsx";
import { TestCreation } from "../../teacher/test-creation/index.jsx";
import { AdminAsyncQuizRoom } from "../../teacher/admin-async-quiz-room";
import { AdminLiveQuizRoom } from "../../teacher/admin-live-room";
import { ClassroomQuizSummary } from "../../teacher/classroom-quiz-summary";

export const TeacherRoutes = () => {
  return (
    <ProtectedRoute allowedRoles={["teacher", "Teacher"]}>
      <Routes>
        <Route path={ROUTE_DASHBOARD} element={<TeacherDashboard />} />
        <Route path={ROUTE_TEST_CREATION} element={<TestCreation />} />
        <Route path={ROUTE_TEST_MANAGEMENT} element={<TestManagement />} />
        <Route path={ROUTE_TEACHER_QUIZ} element={<AdminQuiz />} />
        <Route path={ROUTE_QUESTION_PAPERS} element={<QuestionBank />} />
        <Route path="/teacher/question-papers" element={<QuestionBank />} />
        <Route path="/teacher/question-bank" element={<Navigate to={ROUTE_QUESTION_PAPERS} replace />} />
        <Route path={ROUTE_QUESTION_BANK_VIEW} element={<QuestionBankView />} />
        <Route path={ROUTE_KNOWLEDGE_BASE} element={<KnowledgeBase />} />
        <Route path={ROUTE_ADMIN_QUIZ_ROOM} element={<AdminAsyncQuizRoom />} />
        <Route path={ROUTE_ADMIN_LIVE_QUIZ_ROOM} element={<AdminLiveQuizRoom />} />
        <Route path={ROUTE_CLASSROOM_QUIZ_SUMMARY} element={<ClassroomQuizSummary />} />
        <Route
          path={ROUTE_STUDENT_PERFORMANCE}
          element={<StudentPerformance />}
        />
        <Route
          path={ROUTE_STUDENT_LEADERBOARD}
          element={<TeacherLeaderBaord />}
        />
      </Routes>
    </ProtectedRoute>
  );
};
